import { collectionType } from '../types/collections';
import { scrapType } from '../types/scrapType';

export default function parseIdsFromCollections(collections: collectionType[]): scrapType['collections'] {
  return collections.map((collection) => ({
    id: collection.id,
  }));
}
